const slugPattern = /[^a-z0-9-]+/g;
const orderingPrefixPattern = /^(\d+)[-_ ]+(.+)$/;

export interface SortKey {
  hasPrefix: boolean;
  prefix: number;
  name: string;
}

export function normalizeSlug(input: string): string {
  return input
    .trim()
    .toLowerCase()
    .replaceAll("_", "-")
    .replaceAll(" ", "-")
    .replace(slugPattern, "")
    .replace(/^-+|-+$/g, "");
}

export function stripOrderingPrefix(name: string): string {
  const match = name.match(orderingPrefixPattern);
  return match ? match[2] : name;
}

export function parseSortKey(name: string): SortKey {
  const base = name.replace(/\.[^.]+$/, "");
  const match = base.match(orderingPrefixPattern);
  if (!match) {
    return { hasPrefix: false, prefix: Number.MAX_SAFE_INTEGER, name };
  }
  return { hasPrefix: true, prefix: Number.parseInt(match[1], 10), name };
}

export function compareSortKeys(left: SortKey, right: SortKey): number {
  if (left.hasPrefix !== right.hasPrefix) {
    return left.hasPrefix ? -1 : 1;
  }
  if (left.prefix !== right.prefix) {
    return left.prefix - right.prefix;
  }
  return left.name.localeCompare(right.name);
}

export function fileStem(path: string): string {
  const name = path.split("/").pop() || path;
  return name.replace(/\.[^.]+$/, "");
}
